module.exports = __webpack_public_path__ + "static/media/NoCustomersIcon.713389df.svg";